const pt_BR = {
    homepage_title: 'Baixar CalendarTask versão mobile com código QR',
    homepage_slogn: 'CalendarTask versão mobile',
    homepage_ios_download: 'App Store em análise...',
    homepage_download: 'Baixar',
    homepage_url_calendar: 'https://image.idesktopcal.com/homepage/calendar_normal_chs.png',
    homepage_url_list: 'https://image.idesktopcal.com/homepage/list_normal_chs.png',
    homepage_url_color: 'https://image.idesktopcal.com/homepage/color_normal_chs.png',

    phonedownload_title: 'Baixar CalendarTask versão mobile com código QR',
    phonedownload_slogan: 'Sincronize com PC e tablet, anote em qualquer lugar',
    phonedownload_send_vip: 'Instale o app e receba assinatura VIP',
    phonedownload_screenshot: 'Captura de tela',
    phodedownload_macos: 'CalendarTask versão macOS',
    phodedownload_windows: 'CalendarTask versão Windows',
    phodedownload_otherbutton: 'Ver agora',
    phodedownload_about: 'Contato',
    phodedownload_copyright: '京ICP备18016017号-7',

    feature_no_ad: 'Sem anúncios',
    feature_easy: 'Visualização mensal, simples e fácil',
    feature_reminder: 'Lembrete personalizado',
    feature_countdown: 'Contagem regressiva aniversário',

    vip_task_succ: 'Sucesso. Baixe o app para ativar VIP',
    vip_task_error: 'Recebimento falhou',

    group_slogn: 'Convite CalendarTask equipe',

    tt_title: 'CalendarTask',
    tt_share_1: 'Compartilhado com você',
    tt_share_2: 'Horário',
    tt_share_show_1: 'Escaneie o código QR com o app "CalendarTask", PC e celular mostrarão',
    tt_share_show_2: 'o horário',
    tt_share_scan_1: 'Escanear com',
    tt_share_scan_2: 'app "CalendarTask"',
    tt_share_succ: 'Sincronização bem-sucedida',

    v2_copyright: 'Contato service@xiaoweiyunfu.com<br/>Copyright © 2025 Xiaowei Cloud, Inc. Todos os direitos reservados.',
    v2_download_appstore: 'Baixar na App Store',
    v2_download_googleplay: 'Disponível no Google Play',

    v2_main_title: 'CalendarTask Mobile',
    v2_main_title_part1: 'CalendarTask',
    v2_main_title_part2: 'Mobile',
    v2_main_description: 'Pesquise <span class="name">CalendarTask</span> na App Store ou Google Play',
    v2_download_ios: 'Baixar iOS',
    v2_download_android: 'Baixar Android',
    v2_download_harmonyos: 'Baixar HarmonyOS',
    v2_sync_status: 'Sincronização concluída! 1 enviado, 0 baixados',
    v2_feature_title: 'Sincronização multi-dispositivo',
    v2_feature_description: 'Sincronização entre celular, tablet e PC'
};
export default pt_BR;
